import { Col, Form, Input, Row, Select } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { onLoadAccount } from './../../../actions/settingAcountAction';
import Header from './../../../components/header';
import { renderRowCountry } from './../../../components/render-select';
import SideBar from './../../../components/sidebar-setting';
import { permissions } from './../../../constants';
import avatar from './../../../resources/assets/images/user-grey.png';
import handleException from './../../../services/handleException';
import { setHeight, titleHead } from './../../../services/helper';
import { getAccount } from './../../../utils/settingAccount';
import handlePermission from './../../app/handlePermission';
import './styles.css';

const FormItem = Form.Item

class SettingAccount extends Component {
    updateDimensions() {
        setHeight()
    }

    componentDidMount() {
        titleHead('Setting Account')

        // Set the same height for three column
        setHeight()
        // Set the same height for three column when resize window
        window.addEventListener('resize', this.updateDimensions)

        getAccount().then(account => {
            this.props.onLoadAccount(account.data.data)
        }).catch(error => {
            handleException(error)
        })
    }

    permissions = () => {
        if (!handlePermission(permissions.UserUpdate)) {
            return false
        }
        return true;
    }

    render() {
        const formItemLayout = {
            labelCol: {
                xs: {
                    span: 24,
                },
                sm: {
                    span: 9,
                },
            },
            wrapperCol: {
                xs: {
                    span: 24,
                },
                sm: {
                    span: 13,
                },
            },
        }
        return (
            <div id="setting-account">
                <Header />
                <div className="content">
                    <Row style={{ height: '100%' }}>
                        <Col id="setting-left" className="left-col" span={3}>
                            <SideBar />
                        </Col>
                        <Col id="setting-center" className="left-col" span={9}>
                            <div className="title">
                                <div>
                                    <img className="avatar" src={avatar} />
                                </div>
                                <span className="text-title">My Account</span>
                                <br />
                                <br />
                                <br />
                                <br />
                                <span className="span-change-pass">
                                    [
                                    {this.permissions() ?
                                        <Link to="/change-password"> Change Password </Link>
                                        :
                                        <span> Change Password </span>
                                    }
                                    ]
                                </span>
                            </div>
                        </Col>
                        <Col id="setting-right" className="right-col" span={12}>
                            <div className="verify">
                                <Form layout="vertical">
                                    <Row gutter={8}>
                                        <Col span={24}>
                                            <FormItem {...formItemLayout} label="First Name">
                                                <Input value={this.props.account && this.props.account.FirstNameCH ?  this.props.account.FirstNameCH.trim() : ''} readOnly />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                    <Row gutter={8}>
                                        <Col span={24}>
                                            <FormItem {...formItemLayout} label="Last Name">
                                                <Input value={this.props.account && this.props.account.LastNameCH ? this.props.account.LastNameCH.trim() : ''} readOnly />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                    <Row gutter={8}>
                                        <Col span={24}>
                                            <FormItem {...formItemLayout} label="Company">
                                                <Input value={this.props.account && this.props.account.CompanyCH ? this.props.account.CompanyCH.trim() : ''} readOnly />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                    <Row gutter={8}>
                                        <Col span={24}>
                                            <FormItem {...formItemLayout} label="Email">
                                                <Input value={this.props.account && this.props.account.EmailCH ? this.props.account.EmailCH.trim() : ''} readOnly />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                    <Row gutter={8}>
                                        <Col span={24}>
                                            <FormItem {...formItemLayout} label="Phone Number">
                                                <Input value={this.props.account && this.props.account.Phone ? this.props.account.Phone.trim() : ''} readOnly />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                    <Row gutter={8}>
                                        <Col span={24}>
                                            <FormItem {...formItemLayout} label="Address Line 1">
                                                <Input value={this.props.account && this.props.account.Address1CH ? this.props.account.Address1CH.trim() : ''} readOnly />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                    <Row gutter={8}>
                                        <Col span={24}>
                                            <FormItem {...formItemLayout} label="Address Line 2">
                                                <Input value={this.props.account && this.props.account.Address2CH ? this.props.account.Address2CH.trim() : ''} readOnly />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                    <Row gutter={8}>
                                        <Col span={24}>
                                            <FormItem {...formItemLayout} label="City">
                                                <Input
                                                    value={this.props.account && this.props.account.City ? this.props.account.City.trim() : ''}
                                                    readOnly
                                                />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                    <Row gutter={8}>
                                        <Col span={24}>
                                            <FormItem {...formItemLayout} label="Province">
                                                <Input value={this.props.account && this.props.account.Province ? this.props.account.Province.trim() : ''} readOnly />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                    <Row gutter={8}>
                                        <Col span={24}>
                                            <FormItem {...formItemLayout} label="Postal Code">
                                                <Input value={this.props.account && this.props.account.ZipCode ? this.props.account.ZipCode.trim() : ''} readOnly />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                    <Row gutter={8}>
                                        <Col span={24}>
                                            <FormItem {...formItemLayout} label="Country">
                                                <Select
                                                    disabled
                                                    showSearch
                                                    style={{ width: 257 }}
                                                    placeholder="Select a country"
                                                    optionFilterProp="children"
                                                    value={this.props.account && this.props.account.Country ? this.props.account.Country.trim() : ''}
                                                >
                                                    {renderRowCountry()}
                                                </Select>
                                            </FormItem>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        account: state.settingAccountReducer.account
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onLoadAccount: payload => {
            dispatch(onLoadAccount(payload))
        }
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SettingAccount)


// WEBPACK FOOTER //
// ./src/containers/setting/setting-account/index.js